/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCrmNotificationStatus
 */
export interface UserCrmNotificationStatus {
    /**
     * 
     */
    enable: boolean;
}

/**
 * Check if a given object implements the UserCrmNotificationStatus interface.
 */
export function instanceOfUserCrmNotificationStatus(value: object): value is UserCrmNotificationStatus {
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function UserCrmNotificationStatusFromJSON(json: any): UserCrmNotificationStatus {
    return UserCrmNotificationStatusFromJSONTyped(json, false);
}

export function UserCrmNotificationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCrmNotificationStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'enable': json['enable'],
    };
}

export function UserCrmNotificationStatusToJSON(json: any): UserCrmNotificationStatus {
    return UserCrmNotificationStatusToJSONTyped(json, false);
}

export function UserCrmNotificationStatusToJSONTyped(value?: UserCrmNotificationStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enable': value['enable'],
    };
}

